import axios from "axios";
import { CONFIG } from "@/assets/JS/Config.js";
export default axios.create({ baseURL: CONFIG.apiURL.production });